<template>
<div class="chapter">
<div class="inner_page">
<p class="OT" id="abb"><a id="page_xii"></a><a id="page_xiii"></a><a href="#/xhtml/contents#abb">Abbreviations</a></p>
<table cellpadding="0" cellspacing="0" class="abbre">
<tbody><tr>
<td>ASV</td>
<td>American Standard Version</td>
</tr>
<tr>
<td>BDAG</td>
<td>Danker, Frederick W., Walter Bauer, William F. Arndt, and F. Wilbur Gingrich. <i>Greek-English Lexicon of the New Testament and Other Early Christian Literature</i>, 3rd ed. Chicago: University of Chicago Press, 2000.</td>
</tr>
<tr>
<td>CEB</td>
<td>Common English Version</td>
</tr>
<tr>
<td>ESV</td>
<td>English Stanard Version</td>
</tr>
<tr>
<td>KJV</td>
<td>King James Version</td>
</tr>
<tr>
<td>LCL</td>
<td>Loeb Classical Library</td>
</tr>
<tr>
<td>LXX</td>
<td>Septuagint</td>
</tr>
<tr>
<td>NASB</td>
<td>New American Standard Bible</td>
</tr>
<tr>
<td>NET</td>
<td>New English Translation</td>
</tr>
<tr>
<td>NET</td>
<td>New English Translation</td>
</tr>
<tr>
<td>NETS</td>
<td>New English Translation of the Septuagint</td>
</tr>
<tr>
<td>NIV</td>
<td>New International Version</td>
</tr>
<tr>
<td>NLT</td>
<td>New Living Translation</td>
</tr>
<tr>
<td>NRSV</td>
<td>New Revised Standard Version</td>
</tr>
<tr>
<td>RSV</td>
<td>Revised Standard Version</td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// abbreviations.vue?4fb20d67